import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/F1_Voltage_line.svg"

const F1Voltageline: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 14 18'} component={Icon} {...props} fill="currentColor" />
export default F1Voltageline
